import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, Fragment } from "react";
import TemplateForm from "./templateForm";
import { getTaskAdminIndexPath } from "../../../src/View/Pages/Admin/Task/AdminTaskRoutes";
export default class TaskTemplateCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSuccess: false,
            showError: false,
            error: "",
        };
    }
    render() {
        return (_jsx(Fragment, { children: _jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsx("div", { className: "d-flex justify-content-between", children: _jsxs("h1", { className: "title", children: [_jsx("a", { href: getTaskAdminIndexPath(), className: "text-decoration-none", title: "Back to tags", children: _jsx("span", { className: "fal fa-arrow-circle-left" }) }), " ", "New Template"] }) }) }), _jsxs("div", { role: "main", children: [_jsx(TemplateForm, { onSave: () => this.setState({ showSuccess: true, showError: false }), onError: (error) => this.setState({ showSuccess: false, showError: true, error }), onChange: () => this.setState({ showSuccess: false, showError: false }) }), this.state.showError && (_jsx("div", { className: "alert alert-danger", children: this.state.error
                                    ? `Could not create template.  ${this.state.error}`
                                    : "There was an error creating that template" })), this.state.showSuccess && (_jsx("div", { className: "alert alert-success", children: "Template saved. " }))] })] }) }));
    }
}
